/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum SharedAccessType {
    WRITE = 'WRITE'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const SharedAccessTypeValidatorShape = [
    'WRITE'
];
export const SharedAccessTypeValidator = yup.mixed().oneOf(SharedAccessTypeValidatorShape);
export const SharedAccessTypeStringifyShapeProperties = {};
export const SharedAccessTypeStringifyShape: StringSchema = {
    title: 'SharedAccessType Stringifier',
    type: 'string'
};
export const SharedAccessTypeStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(SharedAccessTypeStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function SharedAccessTypeFromJSON(json: any): SharedAccessType {
    return SharedAccessTypeFromJSONTyped(json, false);
}
export function SharedAccessTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedAccessType {
    return json as SharedAccessType;
}
export function SharedAccessTypeToJSON(value?: SharedAccessType | null): any {
    return value as any;
}
